import { render, staticRenderFns } from "./branchTransactions.vue?vue&type=template&id=366a3980&scoped=true"
import script from "./branchTransactions.vue?vue&type=script&lang=js"
export * from "./branchTransactions.vue?vue&type=script&lang=js"
import style0 from "./branchTransactions.vue?vue&type=style&index=0&id=366a3980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a3980",
  null
  
)

export default component.exports